module.exports = __webpack_public_path__ + "img/logo.943c4f7c.png";